import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { useS3Filter } from "../../contexts/S3FilterContext";

/**
 * Props for SearchTextFilterComponent
 */
export interface SearchTextFilterComponentProps {
  disabled?: boolean;
  loading?: boolean;
}

/**
 * SearchTextFilterComponent - S3 prefix search filter for folder names
 *
 * Allows users to search folders by prefix using S3's native filtering.
 * The search text is appended to the S3 path as a prefix, and S3 returns
 * only items that start with that prefix.
 *
 * Example: If path is "Exports/2025/January/" and user searches "abc",
 * S3 will query "Exports/2025/January/abc" and return only matching items.
 */
export const SearchTextFilterComponent: React.FC<
  SearchTextFilterComponentProps
> = ({ disabled = false, loading = false }) => {
  const { filters, setSearchText } = useS3Filter();

  return (
    <TextField
      fullWidth
      label="Search Folders"
      placeholder="Filter by folder name..."
      value={filters.searchText}
      onChange={(e) => setSearchText(e.target.value)}
      disabled={disabled || loading}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      helperText="S3 prefix search - add trailing '/' for files"
    />
  );
};

export default SearchTextFilterComponent;
